$(document).ready(function () {
    var url = new URL(window.location, 'https://chicopee.com');

    $('#form1_contact').submit(function (e) {
        e.preventDefault();
        var $theForm = $(this);
        var data = $(this).serializeArray();

        $.ajax({
            url: ajaxurl,
            type: 'POST',
            data: data,
            success: function (data) {
                var response = JSON.parse(data);

                if (response.status == 'success') {
                    $theForm.hide();
                    $('.form-error').html('');
                    $('.enquiry-form-title').hide();
                    $('.form-success').fadeIn();
                    $('html, body').animate(
                        {
                            scrollTop: $('.form-success').offset().top - 120,
                        },
                        400
                    );
                    if (url.pathname.includes('/en/')) {
                        cf_gtag_report_conversion(); // conversion located in _meta.php
                    }
                } else if (response.status == 'fail') {
                    $('.form-error').fadeIn();
                    $('.form-error').html('');
                    $(response.errors).each(function (i, index) {
                        $('.form-error').append(
                            '<p style="margin-top: 20px;" class="signup-container__text grey">' +
                                index +
                                '</p>'
                        );
                    });
                }
            },
            error: function (errorThrown) {
                console.log(errorThrown);
            },
        });
    });

    $('#product_sample').submit(function (e) {
        e.preventDefault();
        var $theForm = $(this);
        var data = $(this).serializeArray();

        $.ajax({
            url: $theForm.attr('action'),
            type: 'POST',
            data: data,
            success: function (data) {
                var response = JSON.parse(data);

                if (response.status == 'success') {
                    $theForm.hide();
                    $('.form-error').html('');
                    $('.form-success').fadeIn();
                    $('html, body').animate(
                        {
                            scrollTop: $('.form-success').offset().top - 120,
                        },
                        400
                    );
                    if (url.pathname.includes('/en/')) {
                        ps_gtag_report_conversion(); // conversion located in _meta.php
                    }
                } else if (response.status == 'fail') {
                    $('.form-error').fadeIn();
                    $('.form-error').html('');
                    $(response.errors).each(function (i, index) {
                        $('.form-error').append(
                            '<p style="margin-top: 20px;" class="signup-container__text grey">' +
                                index +
                                '</p>'
                        );
                    });
                }
            },
            error: function (errorThrown) {
                console.log(errorThrown);
            },
        });
    });

    $('#contact_j_cloth').submit(function (e) {
        e.preventDefault();
        var $theForm = $(this);
        var data = $(this).serializeArray();

        $.ajax({
            url: $theForm.attr('action'),
            type: 'POST',
            data: data,
            success: function (data) {
                var response = JSON.parse(data);

                if (response.status == 'success') {
                    $theForm.hide();
                    $('.form-error').html('');
                    $('.form-success').fadeIn();
                } else if (response.status == 'fail') {
                    $('.form-error').fadeIn();
                    $('.form-error').html('');
                    $(response.errors).each(function (i, index) {
                        $('.form-error').append(
                            '<p style="margin-top: 20px;" class="signup-container__text grey">' +
                                index +
                                '</p>'
                        );
                    });
                }
            },
            error: function (errorThrown) {
                console.log(errorThrown);
            },
        });
    });

    $('#microfibre-form').submit(function (e) {
        e.preventDefault();
        var $theForm = $(this);
        var data = $(this).serializeArray();

        $.ajax({
            url: ajaxurl,
            type: 'POST',
            data: data,
            success: function (data) {
                var response = JSON.parse(data);

                if (response.status == 'success') {
                    $theForm.hide();
                    $('.form-error').html('');
                    $('.form-success').fadeIn();
                    // conversions located in header-microfibre.php
                    if (url.pathname.includes('/microfibre/es')) {
                        mf_es_gtag_report_conversion();
                    } else if (url.pathname.includes('/microfibre/fr')) {
                        mf_fr_gtag_report_conversion();
                    } else {
                        mf_gtag_report_conversion();
                    }
                    $('html, body').animate(
                        {
                            scrollTop: $('.form-success').offset().top - 120,
                        },
                        400
                    );
                } else if (response.status == 'fail') {
                    $('.form-error').fadeIn();
                    $('.form-error').html('');
                    $(response.errors).each(function (i, index) {
                        $('.form-error').append(
                            '<p style="margin-top: 20px;" class="signup-container__text grey">' +
                                index +
                                '</p>'
                        );
                    });
                }
            },
            error: function (errorThrown) {
                console.log(errorThrown);
            },
        });
    });
});
